import { OperationMode } from '../core/domain/operationMode'
import { OPERATION_MODE_CODES } from '../core/domain/operationModeConstants'

export const isSorterMode = (operationMode: OperationMode | null): boolean => {
    return operationMode?.code === OPERATION_MODE_CODES.SORTER
}

export const isClassificationMode = (operationMode: OperationMode | null): boolean => {
    return operationMode?.code === OPERATION_MODE_CODES.CLASSIFICATION
}

export const requiresChutesConfiguration = (operationMode: OperationMode | null): boolean => {
    return isSorterMode(operationMode)
}

export const findOperationModeById = (
    modes: OperationMode[],
    id: number
): OperationMode | null => {
    return modes.find(mode => mode.id === id) || null
}

export const findOperationModeByCode = (
    modes: OperationMode[],
    code: string
): OperationMode | null => {
    return modes.find(mode => mode.code === code) || null
}
